import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { FIVE_MINUTES } from '@zet/utils/cacheTime'
import { resetNavigation } from '@zet/utils/navigation'
import storageUtil from '@zet/utils/storage'

import {
  getCreditReport,
  getCreditScoreUrl,
  getUserContext,
  getUserSummary,
  setCustomerNotificationToken,
  setNotificationToken,
} from './functions'
import { UserContext } from './types'

export function useUserContext(isEnabled = true) {
  const queryClient = useQueryClient()
  return useQuery(['userContext'], getUserContext, {
    staleTime: FIVE_MINUTES,
    cacheTime: FIVE_MINUTES,
    enabled: isEnabled,
    onSuccess: (res) => {
      if (res?.isAccBlocked) {
        resetNavigation('AccountBlockedScreen')
      }
    },
    onError: () => {
      const userContext: UserContext | undefined = queryClient.getQueryData([
        'userContext',
      ])
      if (userContext?.id) {
        storageUtil.saveObject('userId', userContext?.id)
      }
    },
  })
}

export function useCreditScoreUrl() {
  return useQuery(['creditScoreUrl'], getCreditScoreUrl)
}

export const useCreditReport = () => {
  return useQuery(['getCreditReport'], getCreditReport)
}

export function useUserSummary() {
  return useQuery(['userSummary'], getUserSummary)
}

export const useSetToken = () => {
  const queryClient = useQueryClient()
  return useMutation(setNotificationToken, {
    onSuccess: (data) => {
      queryClient.setQueryData(['setToken'], data)
    },
  })
}

export const useSetTokenForCustomer = () => {
  const queryClient = useQueryClient()
  return useMutation(setCustomerNotificationToken, {
    onSuccess: (data) => {
      queryClient.setQueryData(['setToken'], data)
    },
  })
}
